import { render } from "./Stepper.vue?vue&type=template&id=ecfbf564"
import script from "./Stepper.vue?vue&type=script&lang=js"
export * from "./Stepper.vue?vue&type=script&lang=js"
script.render = render

export default script